<template>
  <div class="wheel-swipe-notice" :class="{ show: isShow }">
    <svg
      width="90px"
      height="90px"
      fill="white"
      viewBox="0 0 300 300"
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
    >
      <g id="layer">
        <path
          d="M223.193,198.665c0,36.025 -29.31,65.335 -65.335,65.335l-15.717,0c-36.026,0 -65.335,-29.31 -65.335,-65.335l0,-97.33c0,-36.026 29.309,-65.335 65.335,-65.335l4.359,0l0,48.525c-7.134,1.14 -12.607,7.318 -12.607,14.767l0,23.761c0,8.256 6.716,14.973 14.972,14.973l2.269,0c8.256,0 14.973,-6.717 14.973,-14.973l0,-23.761c0,-7.449 -5.475,-13.627 -12.607,-14.767l0,-48.525l4.358,0c36.025,0 65.335,29.309 65.335,65.335l0,97.33Zm-74.328,-107.346l2.269,0c4.397,0 7.973,3.577 7.973,7.973l0,23.761c0,4.396 -3.576,7.973 -7.973,7.973l-2.269,0c-4.396,0 -7.972,-3.577 -7.972,-7.973l0,-23.761c0,-4.396 3.576,-7.973 7.972,-7.973m8.993,-62.319l-15.717,0c-39.886,0 -72.335,32.449 -72.335,72.335l0,97.33c0,39.886 32.449,72.335 72.335,72.335l15.717,0c39.886,0 72.335,-32.449 72.335,-72.335l0,-97.33c0,-39.886 -32.449,-72.335 -72.335,-72.335"
          style="fill-rule:nonzero;"
        />
      </g>
    </svg>
    <span>Turn mouse wheel or swipe screen to slide.</span>
    <svg
      width="90px"
      height="90px"
      fill="white"
      viewBox="0 0 300 300"
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
    >
      <g id="layer">
        <path
          d="M227.516,204.593c-0.637,15.431 -2.501,27.894 -5.393,36.047c-3.255,9.184 -13.21,16.11 -23.154,16.11l-22.61,-0c-8.243,-0 -16.849,-7.088 -21.744,-13.189l-37.069,-52.453c-1.315,-1.86 -1.818,-4.118 -1.417,-6.359c0.4,-2.24 1.654,-4.183 3.53,-5.473c3.777,-2.596 8.867,-1.739 11.583,1.955l16.008,21.761c0.833,1.131 2.299,1.599 3.633,1.163c1.333,-0.438 2.236,-1.684 2.236,-3.088l-0,-73.095c-0,-4.163 3.386,-7.549 7.549,-7.549c4.162,-0 7.549,3.386 7.549,7.549l-0.016,56.623l6.5,-0l0.016,-19.36c0.174,-3.82 3.326,-6.876 7.188,-6.876c3.972,-0 7.204,3.231 7.204,7.204l0.012,23.504l6.5,-0l-0,-16.432c-0,-3.729 3.055,-6.762 6.81,-6.762c3.755,-0 6.81,3.033 6.81,6.762l0.021,21.721l6.5,-0l-0,-14.117c-0,-3.24 2.637,-5.876 5.877,-5.876c3.24,-0 5.877,2.636 5.877,5.876l-0,24.354Zm-144.008,30.618c-6.078,-0 -11.024,-4.945 -11.024,-11.023l-0,-169.914c-0,-6.078 4.946,-11.024 11.024,-11.024l9.459,-0l1.243,4.38c0.902,5.525 5.744,9.661 11.363,9.661l40.67,-0c5.619,-0 10.461,-4.136 11.363,-9.66l1.243,-4.381l9.459,-0c6.078,-0 11.023,4.946 11.023,11.024l-0,97.836c-1.666,0.317 -3.219,0.943 -4.614,1.807l-0,-25.945c-0,-7.747 -6.303,-14.049 -14.049,-14.049c-7.747,-0 -14.049,6.302 -14.049,14.049l-0,63.192l-10.141,-13.785c-4.81,-6.537 -13.816,-8.057 -20.502,-3.46c-3.32,2.281 -5.538,5.722 -6.246,9.688c-0.709,3.965 0.182,7.962 2.507,11.253l28.517,40.351l-57.246,-0Zm138.131,-67.348c-2.288,-0 -4.427,0.635 -6.268,1.722c-1.387,-5.845 -6.656,-10.212 -12.94,-10.212c-2.739,-0 -5.287,0.83 -7.405,2.249c-1.323,-4.395 -4.796,-7.865 -9.195,-9.183l-0,-98.165c-0,-9.663 -7.861,-17.524 -17.523,-17.524l-84.8,-0c-9.662,-0 -17.524,7.861 -17.524,17.524l-0,169.914c-0,9.662 7.862,17.523 17.524,17.523l61.84,-0l4.014,5.681c0.037,0.052 0.075,0.102 0.114,0.152c6.063,7.593 16.31,15.706 26.883,15.706l22.61,-0c12.768,-0 25.082,-8.595 29.281,-20.438c3.929,-11.079 5.303,-26.789 5.763,-38.019c0.002,-0.044 0.003,-0.089 0.003,-0.133l-0,-24.421c-0,-6.824 -5.553,-12.376 -12.377,-12.376"
          style="fill-rule:nonzero;"
        />
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Component definition
export default defineComponent({
  name: "WheelSwipeNotice",
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    duration: {
      type: Number,
      default: 4
    }
  },
  setup() {
    return {};
  }
});
</script>

<!--
 Stylesheet.
 -->
<style scoped lang="scss">
.wheel-swipe-notice {
  display: flex;
  position: absolute;
  justify-content: center;
  margin: 0.2rem;
  padding: 0.4rem;
  color: white;
  left: 50%;
  transform: translateX(-50%);
  bottom: 6%;
  background-color: rgba(#333, 0.9);
  opacity: 0;

  transition: {
    property: opacity;
    duration: 0.4s;
    timing-function: ease-out;
  }
  &.show {
    opacity: 0.9;
  }

  svg {
    margin: 0;
    width: 4rem;
    height: 4rem;
  }

  span {
    margin-top: auto;
    margin-bottom: auto;
  }

  border: {
    style: solid;
    color: white;
    width: 2px;
    radius: 0.6rem;
  }
}
</style>
